import { createContext } from 'react'

import { OnboardingStateReturn } from '../hooks/use-onboarding'

/**
 * Context for managing onboarding state and interactions across the application.
 * Provides access to onboarding status, form data, and modal controls.
 */
export const OnboardingContext = createContext<OnboardingStateReturn>(
  {} as OnboardingStateReturn,
)

OnboardingContext.displayName = 'OnboardingContext'
